<template>
  <div class="info-container">
    <div v-if="!this.isImaginary">
      <div class="text-left">
        <h2 class="header-info">{{ fundMapCompany.short_name[0].name }}</h2>
        <p
          v-for="general_detail in fundMapCompany.general_details"
          class="sub-info"
          :key="general_detail.company_registration_number"
        >
          {{ general_detail.company_registration_number }}
        </p>
        <p v-for="addressObj in fundMapCompany.address" class="sub-info" :key="addressObj.address">
          {{ addressObj.address }}
        </p>
      </div>
    </div>

    <div v-else>
      <div class="text-left">
        <h2 class="header-info">{{ this.fundMapCompany.imaginaryCompany.name }}</h2>
        <p class="sub-info">
          {{ companyForm }}
        </p>
        <p class="sub-info">
          {{ companyAddress }}
        </p>
      </div>
    </div>

    <div v-if="selectedFundMapCategory" class="category-container">
      <span class="category-label">Kiválasztott cél:</span>
      <div class="badge secondary">{{ selectedFundMapCategory.mainCategory.title }}</div>
      <div class="badge primary">{{ selectedFundMapCategory.subCategory.title }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { gfoOptions } from '../views/FundCreation/utils/gfoOptions'
import zipCodes from './zipCodeSelector/zipCodes'

export default {
  data() {
    return {
      gfoOptions: gfoOptions,
      zipCodes: zipCodes,
      isImaginary: false
    }
  },
  computed: {
    ...mapGetters(['fundMapCompany', 'selectedFundMapCategory']),
    companyForm() {
      return this.gfoOptions.find(x => x.item === this.fundMapCompany.imaginaryCompany.form).name
    },
    companyAddress() {
      return this.zipCodes.find(x => x.zip === this.fundMapCompany.imaginaryCompany.address).name
    }
  },
  created() {
    if (this.fundMapCompany.imaginaryCompany) {
      this.isImaginary = true
    }
  }
}
</script>

<style scoped>
.header-info {
  font-weight: 700;
  font-size: 20px;
}

.sub-info {
  color: #344767;
  font-weight: 400;
  font-size: 16px;
}
.info-container {
  padding: 24px 16px;
  border-radius: 8px;
  background-color: #cce9d8;
}
.category-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.category-container .category-label {
  font-size: 16px;
  font-weight: 700;
}

.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border-radius: 4px;
}

.badge.primary {
  color: #fff;
  background-color: #00903c;
}

.badge.secondary {
  color: #000;
  background-color: #dfe6e9;
}
</style>
